import React from 'react';
import PropTypes from 'prop-types';
import SvgActionsLockClosedNormalXsmall from '@strava/icons/ActionsLockClosedNormalXsmall';
import styles from './index.scss';

const HiddenStatIndicator = ({
  hiddenStatIndicatorString,
  showVisibilityMessage
}) => {
  const sectionStyle = showVisibilityMessage
    ? styles.statIndicatorSection
    : styles.visibilitySection;
  const iconStyle = showVisibilityMessage
    ? styles.statIndicatorIcon
    : styles.visibilityIcon;

  return (
    <div className={`${sectionStyle}`} data-testid="stat-indicator-section">
      <div className={`${styles.appIconWrapper} ${styles.iconWrapper}`}>
        <div className={`${iconStyle}`}>
          <span data-testid="stat-indicator-icon">
            <SvgActionsLockClosedNormalXsmall />
          </span>
        </div>
      </div>
      <span data-testid="stat-indicator-string">
        {hiddenStatIndicatorString}
      </span>
    </div>
  );
};

HiddenStatIndicator.propTypes = {
  hiddenStatIndicatorString: PropTypes.string.isRequired,
  showVisibilityMessage: PropTypes.bool.isRequired
};

export default HiddenStatIndicator;
